import { useContext } from 'react';
import SpinContext from '../store/spin-context';

const SpinService = () => {
    const spinContext = useContext(SpinContext);

    const on = () => {
        spinContext.on();
    };

    const off = () => {
        spinContext.off();
    };
    return { on, off };
};

export default SpinService;